import type { ReactNode } from "react";

export function PageHeader({
  title,
  description,
  actions,
  icon,
}: {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  /** Opt-in - most pages don't pass one and are unaffected. A small
   * purple-tinted chip to the left of the title, matching the KpiCard/
   * StatTile icon-chip convention elsewhere, for the rare page whose
   * identity genuinely benefits from one (e.g. Access Management). Not
   * retrofitted onto every PageHeader usage - most page titles are already
   * self-explanatory without one. */
  icon?: ReactNode;
}) {
  return (
    <div className="mb-6 flex flex-wrap items-start justify-between gap-3">
      <div className="flex items-start gap-3">
        {icon && (
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl2 bg-primary-50 text-primary-700">
            {icon}
          </div>
        )}
        <div>
          <h1 className="font-display text-2xl font-semibold tracking-tight text-slate-900">{title}</h1>
          {description && <div className="mt-1 text-sm text-slate-500">{description}</div>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
